<template>
<div style="margin-top:0px">
      <vs-input class="inputx" placeholder="Ürün Ara" @keyup.enter="barkodOku(0)" id="barkodM" :ref="barkod" v-model="barkod" />
      <div class="vx-row">
        <template  v-if="dataSiparisListesi && dataSiparisListesi.length">
            <div  v-bind:id="item.stokKodu" class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base"  v-for="(item,index) in dataSiparisListesi" :key="index">
                <vx-card>
                    <div slot="no-body">
                       
                    </div>
                    <h5 class="mb-2">{{ item.stokAdi }}</h5>
                    <p class="text-grey">{{ item.subtitle }}</p>
                    <p class="text-grey">{{ item.subtitle_2 }}</p>
                    <div class="flex justify-between flex-wrap">
                        <vs-button class="mt-4 mr-2 shadow-lg" type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC" @click="sepeteEkle(item.stokKodu,item.gonderilecekFiyat)">Sepete Ekle</vs-button>
                        <vs-button class="mt-4" type="border" color="#b9b9b9">{{yuvarla(item.gonderilecekFiyat)}} TL</vs-button>
                    </div>
                </vx-card>
            </div>
        </template>



        </div>

        




  




        
</div>

</template>

   


<script>
import vSelect from 'vue-select'
import state from '../../store/state'
import Store from '../../store/store'
import  {isMobile}  from 'mobile-device-detect'
import { jsPDF } from "jspdf"




export default {
  components: {
    'v-select': vSelect,
      },
  data () {
    return {
      gelenId:'',
       card_1: {},
      card_2: {},
      card_3: {},
      card_4: {},
      card_5: {},
      card_6: {},
      card_7: {},
      card_8: {},
          active:false,
      adetKod:'',
        text: "0",
        id: null,
        sayimDurumu:false,
        kdvDurumu:false,
        popupBilgiler:false,
        popupStokListesi:false,
        popupSiparisListesi:false,
        popupPaket:false,
        options: [],
        optionsParti: [],
        pazaryeriTum:[],
        list: [],
        dataStokListesi: [],
        dataSiparisListesi:[],
        ciktiRenkListesi:[],
        ciktiPaketListesi:[],
        listSonFaturalar: [],
        listSiparis:[],
        sipariseGoreUrunListesi:[],
        progress:0,
        activePrompt:false,
        activePromptSiparis:false,
        activePromptTemizle:false,
        popupRenk:false,
        pazaryeriVal:'',
        partiVal:'',
        toplamParca:0,
        selected:{id: 0, label: 'Cari'},
        selectedDepo:'',
        iadeModel:{id: 0, label: 'İade red'},
        selectedParti:{id: 0, label: 'Parti Nolar'},
        popupActive: false,
        popupFatura: false,
        popupActiveSiparis: false,
        popupActiveCikti:false,
        barkod:'',
        barkodAdet:'',
        cariKod:'',
        siparisBulOrderNumber:'',
        genelSiparisNo:'',
        
        genelKargoAdi:'',
        genelKargoNo:'',
        genelMusteri:'',
        hediyeMi:0,
        genelToplam:0,
        eklenenDeger:'',
        indext:0,
        indext1:0,
        urunResim:"",
        validated:1,
        validatedF:1,
        siparisToplamParca:0,
        eklenenToplamParca:0,
        askiDurumu:false,
        aski:0,
        imageLink:"",
        ciktiListesi:[],
        jsonD:'',
        dr:'',
        popupActiveFaturaCikti:false,
        receiptId:0,
        faturaNo:'',
        ilkOkuma:0,
        recId:0,
        total:0,
        faturaAranan:'',
        faturaBulOrderNumber:'',
        im:0,
        iadeOrderNumber:'',
        iadeLineItemId:'',
        barkodAdetKontrol:'',
        ustBolumDeger:0,
        barkodListe:'',
        kontrolAdetSistem:0,
        secilenKod:'',
        aramaKontrol:'',
        tarihs:'',
        gFiyat:'',
        gKdv:'',
        sepet:[],
        indext:0,
        diziS:[],
          }
  },
  methods: {
    sepeteEkle(stokKodu,fiyat) {
            var vm = this
             const vs=this.$vs
      const soap = require('soap')
      const url = state.sistemAddress

      const args = {stokKodu:stokKodu,fiyat:fiyat}
      soap.createClient(url, function(err, client){
      client.sepeteEkle(args, function(err, result){
      

       vm.veriler=JSON.parse(result.sepeteEkleResult)
     //  console.log(vm.veriler)
      if (vm.veriler.response='Ok') {
         vs.notify({
            title: 'Sepet',
            text: "Sepete Eklendi",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })
      }
      // vm.popupSiparisListesi=true;
      })
     
      })
             // commit(setSepet,myJson)
             // Store.state.sepetIslemi=myJSON;
             // console.log(Store.state.sepetIslemi)
    },
    yuvarla(x) {
  return Number.parseFloat(x).toFixed(2);
},
    sortArrays(arrays) {
            return _.orderBy(arrays, 'id', 'asc');
        },
        sortArrays1(arrays) {
            return _.orderBy(arrays, 'guncellemeTarihi', 'desc');
        },
    stokListeAc() {
      this.popupStokListesi=true;

    },
    siteUrunListesi(id) {

       this.dataSiparisListesi=[]
      //this.dataStokListesi=null
      var vm = this
      const soap = require('soap')
      const url = state.sistemAddress

      const args = {program:'Mikro', baslik:'magazaUrunleri',ARANAN:this.$route.params.kategoriId,  token:Store.state.tokenId, companyID:''}
      soap.createClient(url, function(err, client){
      client.standartSorgular(args, function(err, result){
      

       vm.veriler=JSON.parse(result.standartSorgularResult)
       console.log(vm.veriler)
       vm.dataSiparisListesi=vm.veriler 
      // vm.popupSiparisListesi=true;
      })
     
      })



      

    },
    stokListesi() {
      this.dataStokListesi=[]
      //this.dataStokListesi=null
      var vm = this
      const soap = require('soap')
      const url = state.sistemAddress

      const args = {token:Store.state.tokenId,kod:vm.barkodListe,depoNo:this.selectedDepo}
      soap.createClient(url, function(err, client){
      client.stokListesi(args, function(err, result){
        if (result.stokListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

       vm.veriler=JSON.parse(result.stokListesiResult)
       vm.dataStokListesi=vm.veriler 
      })
     
      })


    },
    bilgiler() {
      this.popupBilgiler=true
    },
    barkodAc() {
      this.text='';
    },
    ustBolumDegistir() {
      if (this.ustBolumDeger==1) {
          document.getElementById("ustBolum").style.height='100px'
          this.ustBolumDeger=0
      } else {
      document.getElementById("ustBolum").style.height='0px'
      this.ustBolumDeger=1
      }
    },
    onDecode(a, b, c) {
     // console.log(a, b, c);
     if (this.text=='') {
      this.barkod = a;
      this.barkodOku()
      }
     /* if (this.id) clearTimeout(this.id);
      this.id = setTimeout(() => {
        if (this.text === a) {
          this.text = "";
        }
      }, 5000);*/
    },
    onLoaded() {
     // console.log("load");
    },
    satirEkle(barkod) {
      //alert(barkod)
      this.barkod=barkod
     this.barkodOku()
     this.popupRenk=false
    },
    renkListesi(ortakKod) {
        var vm = this
          const soap = require('soap')
          const url = state.sistemAddress
         //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)
       
          const args = {ortakKod:ortakKod,depoKodu:this.selectedDepo}
          soap.createClient(url, function(err, client){
          client.hizliSiparisRenkListesi(args, function(err, result){
            
          vm.veriler=JSON.parse(result.hizliSiparisRenkListesiResult)
       
          vm.ciktiRenkListesi=vm.veriler
             

          
          })
          })

      vm.popupRenk=true
    },
    paketListesi(stokKodu) {
        var vm = this
          const soap = require('soap')
          const url = state.sistemAddress
         //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)
       
          const args = {stokKodu:stokKodu}
          soap.createClient(url, function(err, client){
          client.paketIcerigi(args, function(err, result){
            
          vm.veriler=JSON.parse(result.paketIcerigiResult)
       
          vm.ciktiPaketListesi=vm.veriler
             

          
          })
          })

      vm.popupPaket=true
    },
    getNow: function() {
                    const today = new Date();
                    const date = today.getDate()+'-'+(today.getMonth()+1)+'-'+today.getFullYear();
                    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    const dateTime = date +' '+ time;
                    return dateTime;
                },
    adetTopla() {
      let toplam=0
      if (this.sipariseGoreUrunListesi!=null & this.sipariseGoreUrunListesi!='') {
      this.sipariseGoreUrunListesi.forEach(element => {
        toplam=toplam+parseInt(element.adet)
      });
      }
      return toplam;
    },toplamTutar() {
      let toplam=0
      if (this.sipariseGoreUrunListesi!=null & this.sipariseGoreUrunListesi!='') {
      this.sipariseGoreUrunListesi.forEach(element => {
        toplam=toplam+parseFloat(element.adet*element.SATIS_FIAT1)
      });
      }
      return toplam;
    },

 

    yazdir() {
       this.$htmlToPaper('printMe')
    },
    siparisYaz() {
     // alert(anaStokKodu)
      var vm = this
       var vs=this.$vs
      const soap = require('soap')
      const url = state.sistemAddress
      //alert(this.kdvDurumu)
      const args = {islemTipi: 'siparis',cariKod:this.selected.id,depoNo:this.selectedDepo,kdvDurumu:this.kdvDurumu}
     // console.log(this.selected.id)
      soap.createClient(url, function(err, client){
      client.depoHizlisatisIslemi(args, function(err, result){
        vm.veriler=JSON.parse(result.depoHizlisatisIslemiResult)
       //console.log(vm.veriler)
         if (vm.veriler.response=='Ok') {
          vs.loading.close("#button-with-loading-partile > .con-vs-loading")
          vs.notify({
            title: 'Sipariş Yazıldı',
            text: "Sipariş Yazıldı",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })
          vm.listeTemizle()
        } else {
          vs.notify({
            title: 'Sipariş Yazılamadı',
            text: "Sipariş Yazmada Hata Oluştu",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'error',
            position:'top-center'
          })
        }
      })
      })


    },

    listedenCikar(id) {
     // alert(anaStokKodu)
      var vm = this
     
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {id: id,cariKodu:this.selected.id,depoKodu:this.selectedDepo}
     // console.log(args)
      soap.createClient(url, function(err, client){
      client.hizliSatisSil(args, function(){
      vm.ps()
      })
      })


    },
    listeyiTemizle() {
       var vm = this
     
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {cariKodu:this.selected.id,depoKodu:this.selectedDepo}
     // console.log(args)
      soap.createClient(url, function(err, client){
      client.hizliSatisTemizle(args, function(){
      vm.ps()
      })
      })


    },
    listedenCikar1(id,barkod) {
     // alert(anaStokKodu)
      this.barkodAdet=-1
      this.barkod=barkod
      this.barkodOku()


    },
    adetDegistir() {
     // alert(anaStokKodu)
    // alert(this.secilenKod)
      this.barkodAdet=this.partiVal
      this.barkod=this.secilenKod
      this.barkodOku('adetDegistir')


    },
  
   
  
    print () {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
    indexbul(array, conditionFn) {
        const item = array.find(conditionFn)
       
        return array.indexOf(item)
      },
    ps1(text) {
      this.partiVal=text
    },
    ps() {
      //alert(this.selectedDepo)
     
        var vm = this
         vm.sipariseGoreUrunListesi=null
       vm.sipariseGoreUrunListesi="";
          const soap = require('soap')
          const url = state.sistemAddress
         //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)
       
          const args = {cariKodu:this.selected.id,depoKodu:this.selectedDepo,islemTipi:0,aranan:this.barkod}
          soap.createClient(url, function(err, client){
          client.acikHizliSiparis(args, function(err, result){
            
          vm.veriler=JSON.parse(result.acikHizliSiparisResult)
       
          vm.sipariseGoreUrunListesi=vm.veriler
             

          
          })
          })

    },
   
    
    secilenPartiUrunleri() {
     const vs=this.$vs
     
          if (this.pazaryeriVal=='' || this.partiVal=='') {
            vs.notify({
            title: 'Paketleme',
            text: "Pazaryerini ve Parti Seçiniz",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
          } else {
                    var vm = this
              
                    const soap = require('soap')
                    const url = state.sistemAddress
                    
                    const args = {pazaryeri: this.pazaryeriVal,partiNo:this.partiVal,token:Store.state.tokenId}
                    soap.createClient(url, function(err, client){
                    client.partiUrunleri(args, function(err, result){
                      if (result.partiUrunleriResult=='-1') {
                        Store.dispatch('logout')
                        //this.$store.dispatch('login', payload)
                      } else {
                        vm.veriler=JSON.parse(result.partiUrunleriResult)
                        vm.total=vm.veriler[0]["tt"]
                        vm.list=vm.veriler
                        


     

                        vm.popupActive=true
                      }
                    
                    })
                    })
          }
     



     
     
   },
   faturaBul() {
      var vm = this
              
                    const soap = require('soap')
                    const url = state.sistemAddress
                    const args = {token:Store.state.tokenId,program: this.pazaryeriVal,EMPLOYEEID:Store.state.plasiyer,faturaAranan:vm.faturaBulOrderNumber}
                    soap.createClient(url, function(err, client){
                    client.sonFaturalar(args, function(err, result){
                      if (result.sonFaturalarResult=='-1') {
                        Store.dispatch('logout')
                        //this.$store.dispatch('login', payload)
                      } else {
                        //console.log(result.sonFaturalarResult)
                        vm.veriler=JSON.parse(result.sonFaturalarResult)
                        //.log(vm.veriler)
                        vm.listSonFaturalar=vm.veriler

                        vm.popupFatura=true
                      }
                    })
                    })
   },
    siparisBul() {
      var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {pazaryeri: "Trendyol",token:Store.state.tokenId,sayfa:0,orderNumber:this.siparisBulOrderNumber}
      soap.createClient(url, function(err, client){
      client.iadeListele(args, function(err, result){
        if (result.iadeListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
          vm.veriler=JSON.parse(result.iadeListeleResult)
      vm.listSiparis=vm.veriler
      vm.popupActiveSiparis=true
        }
      
      
      })
      })

   },
    siparisSec() {

     var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {pazaryeri: "Trendyol",token:Store.state.tokenId,sayfa:0,orderNumber:""}
      soap.createClient(url, function(err, client){
      client.iadeListele(args, function(err, result){
        if (result.iadeListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
          vm.veriler=JSON.parse(result.iadeListeleResult)
      vm.listSiparis=vm.veriler
      vm.popupActiveSiparis=true
        }
      
      
      })
      })



     
     
   },
    barkodOku(islemNe) {
    // alert(gelenorder)
   this.dataSiparisListesi.forEach(element => {
          // alert(element.stokAdi.indexOf(this.barkod))
          if (element.stokAdi.indexOf(this.barkod)==-1) {
            document.getElementById(element.stokKodu).style.display='none';
          } else {
             document.getElementById(element.stokKodu).style.display='inline';
          }
        });
   },


   stokGuncelle() {
          
          const vm=this
          const soap = require('soap')
          const url = state.sistemAddress
          const args = {program: 'Trendyol',token:Store.state.tokenId}
          soap.createClient(url, function(err, client){
          client.stokAdetFiyatGuncelle(args, function(err, result){
            if (result.stokAdetFiyatGuncelleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
            }
          vm.veriler=JSON.parse(result.stokAdetFiyatGuncelleResult)
           
          })
          })
   },
    tekrarIslemeAl(orderNumber,merchantSku,partiNo){

      var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {pazaryeri: this.pazaryeriVal.trim(),token:Store.state.tokenId,orderNumber:orderNumber}
      soap.createClient(url, function(err, client){
      client.tekrarIslemeAl(args, function(err, result){
        if (result.siparisListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
         vm.siparisHazirla(orderNumber,merchantSku,partiNo)
        }
      
      
      })
      })

   },
   
 
    listeTemizle() {
          this.sipariseGoreUrunListesi=[]
          this.validated=1
          this.eklenenToplamParca=0
   },isMobile: function() {

    /*	var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;*/
  return isMobile;
    }
          },
  beforeMount(){
  //  console.log(Store.state.UserId)
  //setInterval(this.stokGuncelle,900000);

     if (this.gelenId!=this.$route.params.kategoriId) {
       this.siteUrunListesi(this.$route.params.kategoriId)
       this.gelenId=this.$route.params.kategoriId
     }
     
              },watch: {
    '$route.params.kategoriId': function (id) {
      this.siteUrunListesi(this.$route.params.kategoriId)
    }
  },
            
  
}

</script>

<style lang="scss" scoped>
.satirRengi { background-color: green; color:white}
.v-select .vs__selected  { font-size:10px;}
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}


</style>
<style lang="stylus">
#parentx
  overflow hidden
  height 500px
  position relative

.header-sidebar
  display flex
  align-items center
  justify-content center
  flex-direction column
  width 100%
  h4
    display flex
    align-items center
    justify-content center
    width 100%
    > button
      margin-left 10px
.footer-sidebar
  display flex
  align-items center
  justify-content space-between
  width 100%
  > button
      border 0px solid rgba(0,0,0,0) !important
      border-left 1px solid rgba(0,0,0,.07) !important
      border-radius 0px !important
</style>